/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import {
  CustomTextField,
  OutlinedButton,
  ContainedButton,
  ModalButton,
  BigModal,
  SelectDropdown,
} from '../index';
import { Typography, Grid, MenuItem } from '@mui/material';
import { useState } from 'react';

export const ProjectModal = (props) => {
  const [editMode, setEditMode] = useState(false);

  return (
    <>
      <BigModal
        open={props.open}
        onClose={props.onClose}
        style={{ width: '65%', p: 0, overflow: 'hidden' }}
      >
        <Grid container>
          <Grid
            item
            xs={12}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              flexDirection: 'column',
            }}
          >
            <Typography
              sx={{
                lineHeight: '1',
                fontWeight: 500,
                fontSize: '20px',
              }}
              margin={0}
              variant="subtitle1"
              align="center"
            >
              Add Details
            </Typography>
            <CustomTextField
              defaultValue={props.projname}
              onChange={props.projNameOnChange}
              required={true}
              disabled={!editMode}
              label="Project Name"
            />
            <CustomTextField
              defaultValue={props.projdesc}
              onChange={props.projDescOnChange}
              required={true}
              disabled={!editMode}
              multiline={true}
              label="Project Description"
            />
            <CustomTextField
              defaultValue={props.projhoursworked}
              onChange={props.projHoursWorkedOnChange}
              required={true}
              disabled={!editMode}
              type={'number'}
              label="Hours Worked"
            />
            <SelectDropdown
              defaultValue={props.projstatus}
              fullWidth={true}
              require={true}
              disabled={!editMode}
              margin="normal"
              onChange={props.projStatusOnChange}
              label="Project Status"
            >
              <MenuItem value={true}>Active</MenuItem>
              <MenuItem value={false}>Inactive</MenuItem>
            </SelectDropdown>
            {!editMode ? (
              <OutlinedButton
                margin="normal"
                fullWidth={true}
                style={{ mt: 'auto' }}
                btnTitle="Edit Information"
                onClick={() => setEditMode(true)}
              />
            ) : (
              <ContainedButton
                margin="normal"
                fullWidth={true}
                btnTitle="Delete Project"
                onClick={props.handleConfirmDelete}
                style={{
                  mt: 'auto',
                  width: '100%',
                  bgcolor: '#d5615d',
                  border: '1px solid #d5615d',
                  '&:hover': {
                    bgcolor: 'rgb(173, 59, 55) !important',
                    borderColor: 'rgb(173, 59, 55)',
                  },
                }}
              />
            )}
            <ModalButton
              margin="normal"
              style={{ mt: 'auto' }}
              primaryBtnName="Save"
              secondaryBtnName="Cancel"
              primaryClickHandler={props.primaryClickHandler}
              secondaryClickHandler={() => {
                setEditMode(false);
                props.secondaryClickHandler();
              }}
            />
          </Grid>
        </Grid>
      </BigModal>
    </>
  );
};
